var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('resume-personal-information', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }), _c('resume-name', {
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }), _c('resume-education', {
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }), _c('resume-work-experience', {
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }), _c('resume-hash-tags', _vm._b({
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }, 'resume-hash-tags', {
    hashTags: _vm.hashTags
  }, false)), _c('resume-languages', {
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }), _c('resume-office-skills', {
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }), _c('resume-certifications', {
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }), _c('resume-cover-letter', {
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }), _c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function ($event) {
        return _vm.save();
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("임시저장")])]), _c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.save(_vm.MICEPEC_RECORDS.value);
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v("저장 후 다음으로")])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }